import type { CSSProperties } from 'react'

export const riskFactorBadge = (rf: string) => {
  switch (rf) {
    case 'LOW':
      return 'badge-light-success'
    case 'MEDIUM':
      return 'badge-light-warning text-dark'
    case 'HIGH':
      return 'badge-light-danger'
    default:
      return 'badge-light-secondary'
  }
}

export const likelihoodBadge = (x: string) => {
  switch (x) {
    case 'ALMOST_CERTAIN':
      return 'badge-light-danger'
    case 'LIKELY':
      return 'badge-light-warning text-dark'
    case 'UNLIKELY':
      return 'badge-light-success'
    case 'POSSIBLE':
      return 'badge-light-warning text-dark'
    case 'REMOTE':
      return 'badge-light-info'
    default:
      return 'badge-light-secondary'
  }
}

export const severityBadge = (x: string) => {
  switch (x) {
    case 'NEGLIGIBLE':
      return 'badge-light-success'
    case 'MINOR':
      return 'badge-light-success'
    case 'SIGNIFICANT':
      return 'badge-light-warning text-dark'
    case 'CRITICAL':
      return 'badge-light-danger'
    default:
      return 'badge-light-secondary'
  }
}

export const niceEnum = (s: string) =>
  s
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())

export const sectionCardStyle = (index: number, mode: 'failure' | 'hazard'): CSSProperties => {
  const even = index % 2 === 0
  if (mode === 'failure') {
    return {
      background: even ? '#f3f6ff' : '#eef9ff',
      borderColor: even ? '#c6d4ff' : '#b7e1f3',
      borderLeft: even ? '4px solid #4f6fd9' : '4px solid #2a8ca8',
    }
  }
  return {
    background: even ? '#fff9ee' : '#f8fff5',
    borderColor: even ? '#e9d8ad' : '#c9e7c1',
    borderLeft: even ? '4px solid #c38a2c' : '4px solid #4f9d62',
  }
}

export const formatRiskLibraryTaskVersion = (v: number) => String(v ?? 0).padStart(2, '0')

export const formatRiskLibraryDateOnly = (dateStr?: string | Date | null): string => {
  if (!dateStr) return ''
  const str = String(dateStr).trim()
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (match) {
    return `${match[3]}/${match[2]}/${match[1]}`
  }
  const d = new Date(str)
  if (isNaN(d.getTime())) {
    return str
  }
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  return `${day}/${month}/${year}`
}
